import {Injectable} from '@angular/core';
import { getKDWBaseUrl } from '../helpers/kdw-base-url.helper';
import { OktaHttpReqService } from './okta-http-req.service';

@Injectable()
export class FaultySegmentService {
    constructor(private oktaHttp: OktaHttpReqService) {}

    // SSPF-3510: routed through segment-api (KDW). See ctx-segment.service.ts.
    private get endpoint(): string {
        return `${getKDWBaseUrl()}/api/v1/faulty_segments`;
    }

    getFaultySegments(params) {
        return this.oktaHttp.request('get', this.endpoint, {params});
    }
}
